
import { newStep } from './step'

export const newAppliance = defaultLocale => ({
  initialSteps: [
    newStep({
      defaultLocale,
      title: 'Step 00',
      type: 'initial',
    }),
  ],
  preparationSteps: [],
  cookingSteps: [],
  finalSteps: [newStep({
    defaultLocale,
    title: 'Step 999',
    type: 'final',
    stepDuration1: 120,
    name: {
      [defaultLocale]: 'Benutzereingabe',
    },
    requiresUserConfirmation: true,
  }),
  newStep({
    defaultLocale,
    title: 'Step 1000',
    type: 'final',
    stepDuration1: 60,
    name: {
      [defaultLocale]: 'Zeit / Leistunge',
    },
  })],
})

export const applianceSpecialTypes = ['kettle', 'blender', 'scale']
